import { Pressable, Text as RNText, View } from 'react-native';

import { cn } from './cn';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

/** Pill segmented control — Live/Fork, Annual/Monthly, Appearance, etc. */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  className,
}: SegmentedControlProps<T>) {
  return (
    <View className={cn('flex-row rounded-xl bg-well p-1', className)}>
      {options.map((o) => {
        const active = o.value === value;
        return (
          <Pressable
            key={o.value}
            onPress={() => onChange(o.value)}
            className={cn('flex-1 items-center rounded-lg py-2', active && 'bg-card')}
          >
            <RNText
              className={cn(
                'font-sans-semibold text-sm',
                active ? 'text-foreground' : 'text-muted',
              )}
            >
              {o.label}
            </RNText>
          </Pressable>
        );
      })}
    </View>
  );
}
